<app-header></app-header>
<div class="tracker-detail pt0">
    <app-step-progress-bar [wizardSteps]="steps" [stepName]="activeStepName" [stepCompleted]="activeStepCompleted">
    </app-step-progress-bar>
    <div class="container">
        <div class="row mt10">
            <div class="col-sm-12">
                <div class="innercard">
                    <h3 class="font24 clrblue mb10 center" translate>lblWeAdvise</h3>
                    <p class="font16 mb10 center lh20" translate>lblOilChangeAdvise</p>
                    <div>
                        <app-checkbox-services-list [currencyType]="currencySymbol" [dyServicesList]="dyServiceList"
                            (onServiceSelection)="selectedServices($event)">
                        </app-checkbox-services-list>
                    </div>
                </div>
            </div>
        </div>
    </div>
</div>
<div class="bottomaction">
    <div class="container">
        <div class="row">
            <div class="col-auto ml-auto">
                <a href="javascript:void(0);" (click)="moveNext();" class="btn btn-primary minwidth"><span
                        translate>lblNext</span></a>
            </div>
        </div>
    </div>
</div>
